import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import {connect} from 'react-redux';
import CopyToClipboard from 'react-copy-to-clipboard';
import {default as Tooltip} from 'components/Tooltip';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import {Request, RequestsMixin, GET} from 'requests';
import {ResourcesMatching, Requesting, Done} from 'requests/components';

const POPOVER_TIMEOUT = 2000;  // in ms

const mapStateToProps = (state, ownProps) => {
  return {
    requests: state.requests,
  };
};

const KitDocumentationController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    children: PropTypes.element,
  },

  contextTypes: {
    kitToken: PropTypes.string.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      shareableDocumentationUrlCopied: false,
    };
  },

  componentWillMount() {
    this.setRequest({
      kit: new Request({
        method: GET,
        url: ['api', 'kits', this.context.kitToken],
      }),
    });
  },

  handleCopied() {
    const disable = () => this.setState({shareableDocumentationUrlCopied: false});

    this.setState({shareableDocumentationUrlCopied: true}, () => {
      setTimeout(disable, POPOVER_TIMEOUT);
    });
  },

  resources() {
    const rm = this.resourceManager();

    return {
      kit: rm.type(this.requests.kit, 'kits').find({token: this.context.kitToken}),
    };
  },

  renderMain() {
    const {kit} = this.resources();
    const {shareableDocumentationUrlCopied} = this.state;
    const shareableDocumentationUrl = `${location.origin}${kit.shareableDocumentationPath}`;
    const shareableDocumentationUrlPopover = (shareableDocumentationUrlCopied) ? <Tooltip noIcon={true} content="Doc Link Copied!" /> : null;

    return (
      <div>
        <div className="dangle-up bg-gray-dark dashed dashed-bottom"></div>

        <div className="container m-xs-b-lg">
          <div className="well bg-body m-xs-b-0 br-b-0 p-xs-x-lg">
            <div className="gg gg-middle">
              <div className="gg-col min-width">
                <i className="ficon ficon-share ficon-2x text-gray-lighter m-xs-r-sm block m-xs-b-sm"></i>
              </div>
              <div className="gg-col p-xs-l-sm p-xs-r-lg">
                <p className="m-xs-b-0">
                  <strong>Share this doc</strong> with your team, clients, or your bookmarks.
                </p>
              </div>
              <div className="gg-col min-width">
                <div className="gg gg-middle">
                  <div className="gg-col bg-gray-lighter inset p-xs-x-md p-xs-y-sm br-l">
                    <div className="shareable-doc-url">
                      <div className="text-truncate font-weight-semibold">
                        {shareableDocumentationUrl}
                      </div>
                    </div>
                  </div>
                  <div className="gg-col min-width has-tooltip">
                    {shareableDocumentationUrlPopover}
                    <CopyToClipboard text={shareableDocumentationUrl} onCopy={this.handleCopied}>
                      <button className="copy-control btn btn-primary p-xs-x-md p-xs-y-sm br-r br-l-0" title="Copy"><i className="ficon ficon-copy"></i></button>
                    </CopyToClipboard>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="well bg-white will-fill-page p-xs-a-lg br-a-0 m-xs-b-0">
            {this.props.children}
          </div>

          <div className="well br-t-0 bg-body p-xs-a-lg dashed dashed-top">
            <p className="m-xs-b-0">
             Need an example or walkthrough? Check out our Fort Awesome how-to guides on <a href="https://articles.fortawesome.com/how-to-using-fort-awesome-icons-f50ab11a2d2a">basic icon use</a>,
             &nbsp;<a href="https://articles.fortawesome.com/how-to-fort-awesome-assets-on-the-desktop-e3fd15df6f43">desktop use</a>, and
             &nbsp;<a href="https://articles.fortawesome.com/how-to-serve-fort-awesome-assets-yourself-5419b88ee2d4">serving things yourself</a>.
            </p>
          </div>

        </div>
      </div>
    );
  },

  renderSpinner() {
    return (
      <div className="is-loading is-loading-icons m-xs-x-0 bg-body p-xs-a-xl br-a">
        <Spinner size={SIZE_LARGE} />
      </div>
    );
  },

  render() {
    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <Requesting any={true} render={this.renderSpinner} />
        <Done all={true} render={this.renderMain} />
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(KitDocumentationController);



// WEBPACK FOOTER //
// ./app/javascript/views/ShareResource/components/ShareResourceController.js